import React from "react";
import "./Team.css";

export const Team = (props) => {
  return (
    <div id="team">
      <div className="container">
        {/* Section Header */}
        <div className="row">
          <div className="col-xs-12">
            <div className="team-header text-center">
              <h2>私たちのチーム</h2>
              <div className="team-subtitle">
                <span className="highlight-text">革新と専門性</span>が交差する場所
              </div>
              <p className="team-description">
                テクノロジーと創造力で世界を変えることができる、私たちはそれを信じています。<br />
                それぞれの領域で専門性を持ちながら、同じ信念を持つメンバーによって、弊社が結成されました。
              </p>
            </div>
          </div>
        </div>

        {/* Team Members */}
        <div className="team-grid">
          <div className="row">
            {props.data && props.data.map((member, index) => (
              <div key={`${member.name}-${index}`} className="col-xs-12 col-md-4">
                <div className="team-member-card">
                  {/* 固定高度的图片区域 */}
                  <div className="member-image-section">
                    <img 
                      src={member.img} 
                      alt={`${member.name} - ${member.job}`} 
                      className="member-image" 
                    />
                  </div>
                  
                  {/* 固定高度的信息区域 */}
                  <div className="member-info-section">
                    {/* 姓名和职位 - 固定高度 */}
                    <div className="member-header-section">
                      <h3 className="member-name">{member.name}</h3>
                      <div className="member-position-wrapper">
                        <span className="member-position">{member.job}</span>
                      </div>
                    </div>
                    
                    {/* 简介区域 - 固定高度 */}
                    <div className="member-bio-section">
                      <p className="member-bio-text">{member.bio}</p>
                    </div>
                    
                    {/* 技能标签区域 - 固定高度 */}
                    <div className="member-skills-section">
                      {index === 1 && (
                        <>
                          <span className="skill-tag">戦略コンサルティング</span>
                          <span className="skill-tag">DX・イノベーション</span>
                          <span className="skill-tag">事業責任者</span>
                        </>
                      )}
                      {index === 0 && (
                        <>
                          <span className="skill-tag">Kaggle Master</span>
                          <span className="skill-tag">LLM開発</span>
                          <span className="skill-tag">データサイエンス</span>
                        </>
                      )}
                      {index === 2 && (
                        <>
                          <span className="skill-tag">ブロックチェーン</span>
                          <span className="skill-tag">クローラー開発</span>
                          <span className="skill-tag">データパイプライン</span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>


      </div>
    </div>
  );
};
